module.exports = __webpack_public_path__ + "static/media/one.20e293f9.jpeg";